module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_18.981c5a45.png";